<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Saved to SAP:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.sap_pushed"
                                        >
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Customer Type:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.customer_type"
                                        >
                                            <option value="b2c">B2C</option>
                                            <option value="b2b">B2B</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Payment Status:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.payment_status"
                                        >
                                            <option value="Pending">
                                                Pending
                                            </option>
                                            <option value="Completed">
                                                Completed
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Order Source:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.source"
                                        >
                                            <option value="POS">O2POS</option>
                                            <option value="ECOMMERCE">
                                                E-Commerce
                                            </option>
                                            <option value="CARE">O2CARE</option>
                                            <option value="ONLINE">
                                                ONLINE
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Delivery Mode:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.delivery_mode"
                                        >
                                            <option
                                                v-for="j in delivery_modes"
                                                :value="j.mode"
                                            >
                                                {{ j.mode }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div
                                    class="col-sm-4"
                                    v-if="
                                        $gate.isZonalManager() == true ||
                                        $gate.isMISAdmin() == true
                                    "
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Branch:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.branch"
                                        >
                                            <option
                                                v-for="branch in branches"
                                                :value="branch.branch_code"
                                            >
                                                {{ branch.branch }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.from_date"
                                            placeholder="From date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.to_date"
                                            placeholder="To date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Phone Number:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a phone number"
                                            v-model="params.phone"
                                            type="number"
                                            min="1000000000"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Customer Name:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a name"
                                            v-model="params.customer_name"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >SAP Doc Number:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter SAP Doc Number"
                                            v-model="params.sapdoc"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Gatepass Number:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter gatepass"
                                            v-model="params.gatepass"
                                            type="number"
                                            min="1"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Draft ID:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter draft order no."
                                            v-model="params.draft_order_id"
                                            type="number"
                                            min="1"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="
                                                getOrders('/api/getDraftOrders')
                                            "
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <!-- main row for all icons  -->
            <div class="col-lg-12">
                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead class="thead-dark">
                                <tr>
                                    <th scope="col">SAP Doc No.</th>
                                    <th scope="col">Branch</th>
                                    <th scope="col">Timestamp</th>
                                    <th scope="col">TYPE</th>
                                    <th scope="col">Customer Info</th>
                                    <th scope="col">Delivery Mode</th>
                                    <th scope="col">Document Value</th>
                                    <th scope="col">View</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="order in orders">
                                    <td>
                                        <p>SAP: {{ order.sap_doc_num }}</p>
                                        <p>Gatepass: {{ order.gatepass_id }}</p>
                                    </td>
                                    <td>
                                        <p>{{ order.branch_code }}</p>
                                    </td>
                                    <td>{{ order.updated_at | timeStamp }}</td>
                                    <td>
                                        <p>{{ order.bill_type }}</p>
                                    </td>
                                    <td>
                                        <p>
                                            <span
                                                v-if="
                                                    order.customer_type == 'b2c'
                                                "
                                                class="badge badge-secondary"
                                                ><b>B2C</b></span
                                            >
                                            <span
                                                v-if="
                                                    order.customer_type == 'b2b'
                                                "
                                                class="badge badge-warning"
                                                ><b>B2B</b></span
                                            >
                                            {{ order.customer_name }}
                                        </p>
                                        <p>{{ order.phone_number }}</p>
                                    </td>
                                    <td>{{ order.delivery_mode }}</td>
                                    <td>{{ order.doc_total }}</td>
                                    <td>
                                        <p v-if="order.sap_doc_num != null">
                                            <button
                                                class="btn btn-secondary"
                                                style="width: 100% !important"
                                                @click="view(order)"
                                            >
                                                View SO
                                                <i class="fas fa-file"></i>
                                            </button>
                                        </p>
                                        <p v-if="order.sap_doc_num == null">
                                            <button
                                                class="btn btn-primary"
                                                style="width: 100% !important"
                                                @click="edit(order)"
                                            >
                                                Order Form
                                                <i
                                                    class="fas fa-arrow-right"
                                                ></i>
                                            </button>
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination
                            :pagination="pagination"
                            @prev="getOrders(pagination.prevPageUrl)"
                            @next="getOrders(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->

        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { pagination: Pagination },

    created() {
        this.usertype = window.user.user_type;
        this.getOrders();
        this.getDeliveryModes();
        this.getBranches();
    },

    data() {
        return {
            orders: [],
            results: "",
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
                branch: "",
            },

            params: new Form({
                sap_pushed: null,
                customer_type: null,
                delivery_mode: null,
                phone: null,
                sapdoc: null,
                gatepass: null,
                customer_name: null,
                payment_status: null,
                from_date: null,
                to_date: null,
                source: null,
                draft_order_id: null,
            }),
            delivery_modes: [],
            branches: [],
        };
    },

    methods: {
        getOrders(url = "/api/getDraftOrders") {
            axios
                .post(url, { results: this.results, params: this.params })
                .then((response) => {
                    this.orders = response.data.data.data;
                    this.configPagination(response.data.data);
                });
        },

        getDeliveryModes() {
            axios.post("/api/getDeliveryModes").then((response) => {
                this.delivery_modes = response.data;
            });
        },

        getBranches() {
            if (this.usertype == "zonal-manager") {
                axios.post("/api/getZonalManagerBranches").then((response) => {
                    this.branches = response.data;
                });
            } else {
                axios.post("/api/getSAPBranches").then((response) => {
                    this.branches = response.data;
                });
            }
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        view(order) {
            window.open("/sale-order/" + order.id, "_blank");
        },

        edit(order) {
            window.open(
                "/create-instant-order/" + order.gatepass_id + "/" + order.id,
                "_blank"
            );
        },

        reset() {
            this.params.reset();
            this.getOrders();
        },
    },
};
</script>
